<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1"><em>Excursuses</em></h1>
<p class="link-para"><span href="#/014_Commentary02#e-1" title="Link target outside of Sample">The Heavens</span></p>
<p class="link-para"><span href="#/016_Commentary04#e-2" title="Link target outside of Sample">Grace and Faith</span></p>
<p class="link-para"><span href="#/023_Commentary11#e-3" title="Link target outside of Sample">Wives and Husbands</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Excursuses.vue?74484ddc